import { render, staticRenderFns } from "./StudentQuizTestFinishView.vue?vue&type=template&id=d0d71730"
import script from "./StudentQuizTestFinishView.vue?vue&type=script&lang=js"
export * from "./StudentQuizTestFinishView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports